// extracted by mini-css-extract-plugin
export var articleList = "article-preview-module--article-list--a632f";
export var link = "article-preview-module--link--1e0ea";
export var meta = "article-preview-module--meta--1cf85";
export var title = "article-preview-module--title--bc587";